/* eslint-disable quotes */
export const candlePensTranslations = {
  'en-GB': {
    candlePens: {
      meta: {
        title: 'Thank you for your Colozoo Candle Pens',
        description: 'Thank you for choosing Colozoo candle pens. Watch the tutorial, leave a review, and get a 10% coupon for other Colozoo products.',
      },
      heroAlt: 'Colozoo candle pens',
      pageTitle: 'Thank you for choosing Colozoo!',
      intro: 'We hope you enjoy your candle pens. Thank you for supporting our small creative brand.',
      help: {
        title: 'Need help?',
        text: 'If anything is wrong with your order, please email us at',
        after: 'We will do everything we can to help.',
      },
      video: {
        title: 'Watch the video & get inspired',
        text: 'Watch our tutorial on YouTube to get started with your candle pens and learn creative decorating techniques.',
        button: 'Watch tutorial',
        badge: 'Easy Quickstart',
        highlight1: 'Various techniques',
        highlight2: '10 minutes',
        highlight3: 'Beginner friendly',
        imageAlt: 'Colozoo candle pens tutorial — decorating a candle',
      },
      review: {
        title: 'Share what you created',
        text: 'How happy are you with your candle pens? Choose your stars below.',
        ratingPrompt: 'Your rating',
        amazonButton: 'Continue to Amazon review',
        amazonHint: 'Please add a photo of what you created — it helps other makers.',
        privateTitle: 'We are sorry it was not perfect',
        privateText: 'Tell us what went wrong. Your message goes to our team only, not to Amazon.',
        messagePlaceholder: 'What can we improve?',
        messageRequired: 'Please tell us a little about your experience',
        emailOptional: 'Email (optional, if you want a reply)',
        sendFeedback: 'Send to Colozoo',
        sending: 'Sending...',
        feedbackSuccessTitle: 'Thank you for your feedback',
        feedbackSuccessMessage: 'We have received your message and will get back to you if needed.',
        feedbackErrorTitle: 'Could not send',
        feedbackErrorMessage: 'Please try again or email support@colozoo.de',
        badge: 'Community',
      },
      coupon: {
        title: 'A little thank-you gift',
        text: 'Enjoy 10% off other Colozoo products with this code:',
        hintBefore: 'Use it in our ',
        hintStoreLink: 'Amazon store',
        hintAfter: '. One code per customer.',
        copy: 'Copy code',
        copied: 'Copied!',
        badge: 'Exclusive Reward',
      },
      newsletter: {
        title: 'Offers and new products',
        text: 'Sign up to receive offers and updates about new Colozoo products. We will not spam you.',
        emailLabel: 'Email address',
        emailPlaceholder: 'you@example.com',
        emailRequired: 'Please enter your email address',
        emailInvalid: 'Please enter a valid email address',
        consent: 'I agree to receive emails about new Colozoo products and offers. I can unsubscribe at any time. See our',
        consentRequired: 'Please agree to receive emails',
        submit: 'Sign up',
        submitting: 'Signing up...',
        successTitle: 'You are on the list!',
        successMessage: 'Thank you! We will send you offers and updates about new products.',
        errorTitle: 'Something went wrong',
        errorMessage: 'Please try again or email support@colozoo.de',
      },
      footer: {
        home: 'Colozoo website',
        legal: 'Legal Notice',
        privacy: 'Privacy Policy',
      },
    },
  },
  'en-US': {
    candlePens: {
      meta: {
        title: 'Thank you for your Colozoo Candle Pens',
        description: 'Thank you for choosing Colozoo candle pens. Watch the tutorial, leave a review, and get a 10% coupon for other Colozoo products.',
      },
      heroAlt: 'Colozoo candle pens',
      pageTitle: 'Thank you for choosing Colozoo!',
      intro: 'We hope you enjoy your candle pens. Thank you for supporting our small creative brand.',
      help: {
        title: 'Need help?',
        text: 'If anything is wrong with your order, please email us at',
        after: 'We will do everything we can to help.',
      },
      video: {
        title: 'Watch the video & get inspired',
        text: 'Watch our tutorial on YouTube to get started with your candle pens and learn creative decorating techniques.',
        button: 'Watch tutorial',
        badge: 'Easy Quickstart',
        highlight1: 'Various techniques',
        highlight2: '10 minutes',
        highlight3: 'Beginner friendly',
        imageAlt: 'Colozoo candle pens tutorial — decorating a candle',
      },
      review: {
        title: 'Share what you created',
        text: 'How happy are you with your candle pens? Choose your stars below.',
        ratingPrompt: 'Your rating',
        amazonButton: 'Continue to Amazon review',
        amazonHint: 'Please add a photo of what you created — it helps other makers.',
        privateTitle: 'We are sorry it was not perfect',
        privateText: 'Tell us what went wrong. Your message goes to our team only, not to Amazon.',
        messagePlaceholder: 'What can we improve?',
        messageRequired: 'Please tell us a little about your experience',
        emailOptional: 'Email (optional, if you want a reply)',
        sendFeedback: 'Send to Colozoo',
        sending: 'Sending...',
        feedbackSuccessTitle: 'Thank you for your feedback',
        feedbackSuccessMessage: 'We have received your message and will get back to you if needed.',
        feedbackErrorTitle: 'Could not send',
        feedbackErrorMessage: 'Please try again or email support@colozoo.de',
        badge: 'Community',
      },
      coupon: {
        title: 'A little thank-you gift',
        text: 'Enjoy 10% off other Colozoo products with this code:',
        hintBefore: 'Use it in our ',
        hintStoreLink: 'Amazon store',
        hintAfter: '. One code per customer.',
        copy: 'Copy code',
        copied: 'Copied!',
        badge: 'Exclusive Reward',
      },
      newsletter: {
        title: 'Offers and new products',
        text: 'Sign up to receive offers and updates about new products. We will not spam you.',
        emailLabel: 'Email address',
        emailPlaceholder: 'you@example.com',
        emailRequired: 'Please enter your email address',
        emailInvalid: 'Please enter a valid email address',
        consent: 'I agree to receive emails about new Colozoo products and offers. I can unsubscribe at any time. See our',
        consentRequired: 'Please agree to receive emails',
        submit: 'Sign up',
        submitting: 'Signing up...',
        successTitle: 'You are on the list!',
        successMessage: 'Thank you! We will send you offers and updates about new products.',
        errorTitle: 'Something went wrong',
        errorMessage: 'Please try again or email support@colozoo.de',
      },
      footer: {
        home: 'Colozoo website',
        legal: 'Legal Notice',
        privacy: 'Privacy Policy',
      },
    },
  },
  de: {
    candlePens: {
      meta: {
        title: 'Danke für Deine Colozoo Kerzenstifte',
        description: 'Danke, dass Du Dich für Colozoo Kerzenstifte entschieden hast. Schau Dir das Tutorial an, hinterlasse eine Bewertung und sichere Dir 10 % auf andere Colozoo-Produkte.',
      },
      heroAlt: 'Colozoo Kerzenstifte',
      pageTitle: 'Danke, dass Du Dich für Colozoo entschieden hast!',
      intro: 'Wir hoffen, Du hast Freude an Deinen Kerzenstiften. Danke, dass Du unsere kleine kreative Marke unterstützt.',
      help: {
        title: 'Brauchst Du Hilfe?',
        text: 'Wenn etwas mit Deiner Bestellung nicht stimmt, schreib uns bitte an',
        after: 'Wir tun alles, um Dir zu helfen.',
      },
      video: {
        title: 'Video ansehen & inspirieren lassen',
        text: 'Im YouTube-Tutorial siehst Du, wie Du Deine Kerzenstifte verwendest und kreative Dekotechniken lernst.',
        button: 'Tutorial ansehen',
        badge: 'Schnellstart',
        highlight1: 'Verschiedene Techniken',
        highlight2: '10 Minuten',
        highlight3: 'Für Einsteiger',
        imageAlt: 'Colozoo Kerzenstifte Tutorial — Kerze dekorieren',
      },
      review: {
        title: 'Zeig uns, was Du gemacht hast',
        text: 'Wie zufrieden bist Du mit Deinen Kerzenstiften? Wähle unten Deine Sterne.',
        ratingPrompt: 'Deine Bewertung',
        amazonButton: 'Weiter zur Amazon-Bewertung',
        amazonHint: 'Bitte füge ein Foto Deiner Kreation hinzu — das hilft anderen.',
        privateTitle: 'Schade, dass es nicht perfekt war',
        privateText: 'Sag uns, was schief gelaufen ist. Deine Nachricht geht nur an unser Team, nicht an Amazon.',
        messagePlaceholder: 'Was können wir verbessern?',
        messageRequired: 'Bitte beschreibe kurz Deine Erfahrung',
        emailOptional: 'E-Mail (optional, für eine Antwort)',
        sendFeedback: 'An Colozoo senden',
        sending: 'Wird gesendet...',
        feedbackSuccessTitle: 'Danke für Dein Feedback',
        feedbackSuccessMessage: 'Wir haben Deine Nachricht erhalten und melden uns bei Bedarf.',
        feedbackErrorTitle: 'Senden fehlgeschlagen',
        feedbackErrorMessage: 'Bitte versuche es erneut oder schreibe an support@colozoo.de',
        badge: 'Community',
      },
      coupon: {
        title: 'Ein kleines Dankeschön',
        text: 'Spare 10 % auf andere Colozoo-Produkte mit diesem Code:',
        hintBefore: 'Einlösbar in unserem ',
        hintStoreLink: 'Amazon-Shop',
        hintAfter: '. Einmal pro Kunde.',
        copy: 'Code kopieren',
        copied: 'Kopiert!',
        badge: 'Exklusives Dankeschön',
      },
      newsletter: {
        title: 'Angebote und neue Produkte',
        text: 'Melde Dich an, um Angebote und Neuigkeiten zu neuen Colozoo-Produkten zu erhalten. Wir spammen Dich nicht.',
        emailLabel: 'E-Mail-Adresse',
        emailPlaceholder: 'du@example.com',
        emailRequired: 'Bitte gib Deine E-Mail-Adresse ein',
        emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
        consent: 'Ich bin einverstanden, E-Mails zu neuen Colozoo-Produkten und Angeboten zu erhalten. Ich kann mich jederzeit abmelden. Siehe unsere',
        consentRequired: 'Bitte stimme dem Empfang von E-Mails zu',
        submit: 'Anmelden',
        submitting: 'Wird angemeldet...',
        successTitle: 'Du bist auf der Liste!',
        successMessage: 'Danke! Wir senden Dir Angebote und Neuigkeiten zu neuen Produkten.',
        errorTitle: 'Etwas ist schiefgelaufen',
        errorMessage: 'Bitte versuche es erneut oder schreib an support@colozoo.de',
      },
      footer: {
        home: 'Colozoo Webseite',
        legal: 'Impressum',
        privacy: 'Datenschutzerklärung',
      },
    },
  },
  fr: {
    candlePens: {
      meta: {
        title: 'Merci pour vos stylos bougie Colozoo',
        description: 'Merci d\'avoir choisi les stylos bougie Colozoo. Regardez le tutoriel, laissez un avis et profitez de 10 % sur d\'autres produits Colozoo.',
      },
      heroAlt: 'Stylos bougie Colozoo',
      pageTitle: 'Merci d\'avoir choisi Colozoo !',
      intro: 'Nous espérons que vous apprécierez vos stylos bougie. Merci de soutenir notre petite marque créative.',
      help: {
        title: 'Besoin d\'aide ?',
        text: 'Si quelque chose ne va pas avec votre commande, écrivez-nous à',
        after: 'Nous ferons tout notre possible pour vous aider.',
      },
      video: {
        title: 'Regardez la vidéo et inspirez-vous',
        text: 'Découvrez notre tutoriel sur YouTube pour commencer avec vos stylos bougie et apprendre des techniques de décoration.',
        button: 'Voir le tutoriel',
        badge: 'Démarrage rapide',
        highlight1: 'Diverses techniques',
        highlight2: '10 minutes',
        highlight3: 'Débutants',
        imageAlt: 'Tutoriel stylos bougie Colozoo — décorer une bougie',
      },
      review: {
        title: 'Montrez-nous votre création',
        text: 'Quel est votre avis sur vos stylos à bougie ? Choisissez vos étoiles ci-dessous.',
        ratingPrompt: 'Votre note',
        amazonButton: 'Continuer vers l\'avis Amazon',
        amazonHint: 'Ajoutez une photo de ce que vous avez créé — cela aide les autres.',
        privateTitle: 'Nous sommes désolés que ce ne soit pas parfait',
        privateText: 'Dites-nous ce qui n\'a pas marché. Votre message va uniquement à notre équipe, pas à Amazon.',
        messagePlaceholder: 'Que pouvons-nous améliorer ?',
        messageRequired: 'Merci de nous décrire brièvement votre expérience',
        emailOptional: 'E-mail (facultatif, pour une réponse)',
        sendFeedback: 'Envoyer à Colozoo',
        sending: 'Envoi...',
        feedbackSuccessTitle: 'Merci pour votre retour',
        feedbackSuccessMessage: 'Nous avons bien reçu votre message et vous recontacterons si nécessaire.',
        feedbackErrorTitle: 'Envoi impossible',
        feedbackErrorMessage: 'Réessayez ou écrivez à support@colozoo.de',
        badge: 'Communauté',
      },
      coupon: {
        title: 'Un petit merci',
        text: 'Profitez de 10 % de réduction sur les autres produits Colozoo avec ce code :',
        hintBefore: 'Valable dans notre ',
        hintStoreLink: 'boutique Amazon',
        hintAfter: '. Un code par client.',
        copy: 'Copier le code',
        copied: 'Copié !',
        badge: 'Récompense exclusive',
      },
      newsletter: {
        title: 'Offres et nouveaux produits',
        text: 'Inscrivez-vous pour recevoir des offres et des actualités sur les nouveaux produits Colozoo. Nous ne vous spammerons pas.',
        emailLabel: 'Adresse e-mail',
        emailPlaceholder: 'vous@exemple.com',
        emailRequired: 'Veuillez entrer votre adresse e-mail',
        emailInvalid: 'Veuillez entrer une adresse e-mail valide',
        consent: 'J\'accepte de recevoir des e-mails sur les nouveaux produits et offres Colozoo. Je peux me désinscrire à tout moment. Voir notre',
        consentRequired: 'Veuillez accepter de recevoir des e-mails',
        submit: 'S\'inscrire',
        submitting: 'Inscription...',
        successTitle: 'Vous êtes sur la liste !',
        successMessage: 'Merci ! Nous vous enverrons des offres et des actualités sur les nouveaux produits.',
        errorTitle: 'Une erreur s\'est produite',
        errorMessage: 'Veuillez réessayer ou écrire à support@colozoo.de',
      },
      footer: {
        home: 'Site Colozoo',
        legal: 'Mentions légales',
        privacy: 'Politique de confidentialité',
      },
    },
  },
  it: {
    candlePens: {
      meta: {
        title: 'Grazie per le tue penne per candele Colozoo',
        description: 'Grazie per aver scelto le penne per candele Colozoo. Guarda il tutorial, lascia una recensione e ottieni il 10% su altri prodotti Colozoo.',
      },
      heroAlt: 'Penne per candele Colozoo',
      pageTitle: 'Grazie per aver scelto Colozoo!',
      intro: 'Speriamo che tu apprezzi le tue penne per candele. Grazie per sostenere il nostro piccolo marchio creativo.',
      help: {
        title: 'Hai bisogno di aiuto?',
        text: 'Se qualcosa non va con il tuo ordine, scrivici a',
        after: 'Faremo tutto il possibile per aiutarti.',
      },
      video: {
        title: 'Guarda il video e lasciati ispirare',
        text: 'Guarda il nostro tutorial su YouTube per iniziare con le tue penne per candele e imparare tecniche di decorazione.',
        button: 'Guarda il tutorial',
        badge: 'Inizio rapido',
        highlight1: 'Varie tecniche',
        highlight2: '10 minuti',
        highlight3: 'Per principianti',
        imageAlt: 'Tutorial penne candela Colozoo — decorare una candela',
      },
      review: {
        title: 'Mostraci cosa hai creato',
        text: 'Quanto ti piacciono i tuoi penna-candela? Scegli le stelle qui sotto.',
        ratingPrompt: 'La tua valutazione',
        amazonButton: 'Continua alla recensione Amazon',
        amazonHint: 'Aggiungi una foto di ciò che hai creato — aiuta gli altri.',
        privateTitle: 'Ci dispiace che non sia stato perfetto',
        privateText: 'Dicci cosa non ha funzionato. Il messaggio va solo al nostro team, non ad Amazon.',
        messagePlaceholder: 'Cosa possiamo migliorare?',
        messageRequired: 'Descrivi brevemente la tua esperienza',
        emailOptional: 'E-mail (facoltativa, per una risposta)',
        sendFeedback: 'Invia a Colozoo',
        sending: 'Invio...',
        feedbackSuccessTitle: 'Grazie per il feedback',
        feedbackSuccessMessage: 'Abbiamo ricevuto il messaggio e ti contatteremo se necessario.',
        feedbackErrorTitle: 'Invio non riuscito',
        feedbackErrorMessage: 'Riprova o scrivi a support@colozoo.de',
        badge: 'Community',
      },
      coupon: {
        title: 'Un piccolo grazie',
        text: 'Goditi il 10% di sconto su altri prodotti Colozoo con questo codice:',
        hintBefore: 'Utilizzalo nel nostro ',
        hintStoreLink: 'store Amazon',
        hintAfter: '. Un codice per cliente.',
        copy: 'Copia codice',
        copied: 'Copiato!',
        badge: 'Premio esclusivo',
      },
      newsletter: {
        title: 'Offerte e nuovi prodotti',
        text: 'Iscriviti per ricevere offerte e aggiornamenti sui nuovi prodotti Colozoo. Non ti spammeremo.',
        emailLabel: 'Indirizzo email',
        emailPlaceholder: 'tu@esempio.com',
        emailRequired: 'Inserisci il tuo indirizzo email',
        emailInvalid: 'Inserisci un indirizzo email valido',
        consent: 'Accetto di ricevere email su nuovi prodotti e offerte Colozoo. Posso disiscrivermi in qualsiasi momento. Vedi la nostra',
        consentRequired: 'Accetta di ricevere le email',
        submit: 'Iscriviti',
        submitting: 'Iscrizione...',
        successTitle: 'Sei in lista!',
        successMessage: 'Grazie! Ti invieremo offerte e aggiornamenti sui nuovi prodotti.',
        errorTitle: 'Qualcosa è andato storto',
        errorMessage: 'Riprova o scrivi a support@colozoo.de',
      },
      footer: {
        home: 'Sito Colozoo',
        legal: 'Note legali',
        privacy: 'Informativa sulla privacy',
      },
    },
  },
  es: {
    candlePens: {
      meta: {
        title: 'Gracias por tus rotuladores para velas Colozoo',
        description: 'Gracias por elegir los rotuladores para velas Colozoo. Mira el tutorial, deja una reseña y obtén un 10% en otros productos Colozoo.',
      },
      heroAlt: 'Rotuladores para velas Colozoo',
      pageTitle: '¡Gracias por elegir Colozoo!',
      intro: 'Esperamos que disfrutes de tus rotuladores para velas. Gracias por apoyar nuestra pequeña marca creativa.',
      help: {
        title: '¿Necesitas ayuda?',
        text: 'Si hay algún problema con tu pedido, escríbenos a',
        after: 'Haremos todo lo posible para ayudarte.',
      },
      video: {
        title: 'Mira el vídeo e inspírate',
        text: 'Mira nuestro tutorial en YouTube para empezar con tus rotuladores para velas y aprender técnicas de decoración.',
        button: 'Ver tutorial',
        badge: 'Inicio rápido',
        highlight1: 'Varias técnicas',
        highlight2: '10 minutos',
        highlight3: 'Para principiantes',
        imageAlt: 'Tutorial rotuladores Colozoo — decorar una vela',
      },
      review: {
        title: 'Muéstranos lo que has creado',
        text: '¿Qué te parecen tus rotuladores para velas? Elige tus estrellas abajo.',
        ratingPrompt: 'Tu valoración',
        amazonButton: 'Continuar a la reseña en Amazon',
        amazonHint: 'Añade una foto de lo que has creado: ayuda a otras personas.',
        privateTitle: 'Lamentamos que no fuera perfecto',
        privateText: 'Cuéntanos qué salió mal. Tu mensaje va solo a nuestro equipo, no a Amazon.',
        messagePlaceholder: '¿Qué podemos mejorar?',
        messageRequired: 'Cuéntanos brevemente tu experiencia',
        emailOptional: 'Correo (opcional, si quieres respuesta)',
        sendFeedback: 'Enviar a Colozoo',
        sending: 'Enviando...',
        feedbackSuccessTitle: 'Gracias por tu opinión',
        feedbackSuccessMessage: 'Hemos recibido tu mensaje y te contactaremos si hace falta.',
        feedbackErrorTitle: 'No se pudo enviar',
        feedbackErrorMessage: 'Inténtalo de nuevo o escribe a support@colozoo.de',
        badge: 'Comunidad',
      },
      coupon: {
        title: 'Un pequeño agradecimiento',
        text: 'Disfruta de un 10% de descuento en otros productos Colozoo con este código:',
        hintBefore: 'Úsalo en nuestra ',
        hintStoreLink: 'tienda de Amazon',
        hintAfter: '. Un código por cliente.',
        copy: 'Copiar código',
        copied: '¡Copiado!',
        badge: 'Recompensa exclusiva',
      },
      newsletter: {
        title: 'Ofertas y nuevos productos',
        text: 'Regístrate para recibir ofertas y novedades sobre nuevos productos Colozoo. No te enviaremos spam.',
        emailLabel: 'Dirección de correo',
        emailPlaceholder: 'tu@ejemplo.com',
        emailRequired: 'Introduce tu dirección de correo',
        emailInvalid: 'Introduce un correo electrónico válido',
        consent: 'Acepto recibir correos sobre nuevos productos y ofertas de Colozoo. Puedo darme de baja en cualquier momento. Consulta nuestra',
        consentRequired: 'Acepta recibir correos electrónicos',
        submit: 'Suscribirme',
        submitting: 'Suscribiendo...',
        successTitle: '¡Estás en la lista!',
        successMessage: '¡Gracias! Te enviaremos ofertas y novedades sobre nuevos productos.',
        errorTitle: 'Algo ha salido mal',
        errorMessage: 'Inténtalo de nuevo o escribe a support@colozoo.de',
      },
      footer: {
        home: 'Web de Colozoo',
        legal: 'Aviso legal',
        privacy: 'Política de privacidad',
      },
    },
  },
}
